import React from "react"
import PropTypes from "prop-types"
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Box,
  Typography,
  Collapse,
} from "@mui/material"

const SidebarCentralNavButton = ({
  item,
  collapsed,
  active,
  openSubmenu,
  idx,
  handleSubmenuToggle,
}) => {
  return (
    <Box
      sx={{
        borderRadius: 2,
        mx: 1,
        mb: 0,
      }}
    >
      <Tooltip
        title={collapsed ? item.label : (item.tooltip ?? "")}
        placement="right"
        disableInteractive={false}
      >
        <span style={{ display: "flex", width: "100%" }}>
          <ListItem
            button
            component={item.link ? "a" : "div"}
            href={item.link || undefined}
            data-element={item.dataElement || undefined}
            onClick={item.submenu ? () => handleSubmenuToggle(idx) : undefined}
            disabled={item.disabled}
            sx={{
              justifyContent: collapsed ? "center" : "flex-start",
              transition: "opacity 0.2s",
              backgroundColor: active ? "#ffd52b !important" : "transparent",
              borderRadius: 2,
              textDecoration: "none",
              color: "inherit",
              fontWeight: 400,
              opacity: item.disabled ? 0.8 : 1,
              "&:visited": { color: "inherit" },
              "&:active": { color: "inherit" },
              "&:hover": { color: "inherit" },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: collapsed ? 0 : 1,
                justifyContent: "center",
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontFamily: "Roboto, Arial, sans-serif",
                      fontSize: 16,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.label}
                  </Typography>
                  {!collapsed && item.rightIcon && (
                    <Box sx={{ ml: 1, display: "flex", alignItems: "center" }}>
                      {item.rightIcon}
                    </Box>
                  )}
                </Box>
              }
              sx={{
                opacity: collapsed ? 0 : 1,
                pointerEvents: collapsed ? "none" : "auto",
                transition: "opacity 0.2s",
              }}
            />
          </ListItem>
        </span>
      </Tooltip>
      {item.submenu && !collapsed && (
        <Collapse in={openSubmenu === idx} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {item.submenu.map((sub, subIdx) => (
              <Box
                key={subIdx}
                sx={{ bgcolor: "transparent", borderRadius: 2, mx: 1, mb: 0 }}
              >
                <Tooltip
                  title={sub.tooltip || ""}
                  placement="right"
                  disableInteractive={false}
                >
                  <span style={{ display: "flex", width: "100%" }}>
                    <ListItem
                      button
                      component={sub.link ? "a" : "div"}
                      href={sub.link || undefined}
                      disabled={sub.disabled}
                      sx={{
                        pl: 2,
                        backgroundColor: "transparent",
                        borderRadius: 2,
                        fontWeight: 400,
                        textDecoration: "none",
                        color: "inherit",
                        opacity: sub.disabled ? 0.5 : 1,
                        "&:visited": { color: "inherit" },
                        "&:active": { color: "inherit" },
                        "&:hover": { color: "inherit" },
                      }}
                    >
                      <ListItemText
                        primary={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 400,
                                fontFamily: "Roboto, Arial, sans-serif",
                                fontSize: 16,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {sub.label}
                            </Typography>
                            {!collapsed && sub.rightIcon && (
                              <Box
                                sx={{
                                  ml: 1,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {sub.rightIcon}
                              </Box>
                            )}
                          </Box>
                        }
                        sx={{}}
                      />
                    </ListItem>
                  </span>
                </Tooltip>
              </Box>
            ))}
          </List>
        </Collapse>
      )}
    </Box>
  )
}

SidebarCentralNavButton.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.node,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    rightIcon: PropTypes.node,
    tooltip: PropTypes.string,
    link: PropTypes.string,
    dataElement: PropTypes.string,
    submenu: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        link: PropTypes.string,
        disabled: PropTypes.bool,
        rightIcon: PropTypes.node,
        tooltip: PropTypes.string,
      }),
    ),
  }).isRequired,
  active: PropTypes.bool,
  collapsed: PropTypes.bool.isRequired,
  openSubmenu: PropTypes.number,
  idx: PropTypes.number.isRequired,
  handleSubmenuToggle: PropTypes.func.isRequired,
}

export default SidebarCentralNavButton
